import React from 'react'

const ChipsList = ({ destinations, onClick }) => {

  return (
    <ul className="chips__list">
      {
        destinations
        .filter(({ active }) => active)
        .map(({ name, value, id }) => (
          <li className="chips__item" key={value + id}>
            {name}
            <span
              className="icon-close chips__close"
              onClick={() => onClick(id)}
            />
          </li>
        ))
      }
    </ul>
  )
}

export default ChipsList